//
//
//
//
//
//
//
//
//

export default {
  name: 'star-level',
  props: {
    stars: {
      type: Number | String,
      default: 1
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/StarLevel/StarLevel.vue